<template>
  <div class="template-category">
    <div
      v-if="!headerHidden"
      class="template-category__title-container"
    >
      <div class="template-category__title">
        {{ title }}
      </div>
      <div class="template-category__slider-buttons">
        <button
          type="button"
          class="template-category__slider-button  prev-slide"
          @click="goToPrevSlide"
        />
        <button
          type="button"
          class="template-category__slider-button"
          @click="goToNextSlide"
        />
      </div>
    </div>
    <div class="template-category__carousel-container">
      <VueSlickCarousel
        ref="carousel"
        v-bind="carouselSettings"
        @beforeChange="handleBeforeChange"
        @afterChange="handleAfterChange"
      >
        <slot/>
      </VueSlickCarousel>
    </div>
  </div>
</template>

<script>
import 'vue-slick-carousel/dist/vue-slick-carousel.css';

const VueSlickCarousel = () => import('vue-slick-carousel');

export default {
  name: 'TCarousel',
  components: {
    VueSlickCarousel,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    headerHidden: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      carouselSettings: {
        infinite: false,
        slidesToScroll: 1,
        initialSlide: 0,
        variableWidth: true,
        swipeToSlide: true,
        draggable: true,
        touchMove: true,
        arrows: false,
      },
      isScrolling: false,
    };
  },
  methods: {
    goToPrevSlide() {
      this.$refs.carousel.prev();
    },
    goToNextSlide() {
      this.$refs.carousel.next();
    },
    handleBeforeChange() {
      this.isScrolling = true;
      this.$emit('scrolling', true);
    },
    handleAfterChange() {
      this.isScrolling = false;
      this.$emit('scrolling', false);
    },
  },
};
</script>

<style
  lang="scss"
>
@import "~@/assets/scss/mixins/index";

.template-category {
  color: var(--gray-1);

  &__carousel-item {
    margin: 0 0 0 8px;

    @include media-lg() {
      margin: 0 8px 0 0;
    }
  }

  &__carousel-container {
    @include media-sm-only() {
      margin: 0 -24px;
    }
    @include media-lg() {
      margin-right: -32px;
    }
  }

  &__title-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
  }

  &__title {
    font-size: 19px;
    line-height: 130%;
  }

  &__slider-buttons {
    display: flex;
    gap: 8px;
  }

  &__slider-button {
    width: 42px;
    height: 42px;
    border-radius: 50%;
    border: 1px solid var(--muted);
    background-image: url("~@/assets/icons/arrow-stick.svg");
    background-repeat: no-repeat;
    background-position: center;
    background-size: 14px;
    background-color: var(--light);

    &.prev-slide {
      transform: rotatez(180deg);
    }
  }
}
</style>
